import React from 'react';
import { Link } from 'react-router-dom';
import { FiRefreshCw, FiClock, FiCheckCircle, FiAlertCircle, FiMail } from 'react-icons/fi';
import './Returns.css';

const Returns = () => {
  const steps = [
    {
      icon: <FiCheckCircle />,
      title: '1. Check Eligibility',
      description: 'Ensure items are unworn, unwashed, with original tags attached within 30 days of delivery.'
    },
    {
      icon: <FiMail />,
      title: '2. Initiate Return',
      description: 'Contact us or log into your account to request a return and receive a shipping label.'
    },
    {
      icon: <FiRefreshCw />,
      title: '3. Pack & Ship',
      description: 'Pack items securely and drop off at any authorized shipping location.'
    },
    {
      icon: <FiClock />,
      title: '4. Receive Refund',
      description: 'Refund processed within 5-7 business days after we receive your return.'
    }
  ];

  return (
    <div className="returns-page">
      {/* Hero Section */}
      <section className="returns-hero">
        <div className="container">
          <h1 className="returns-hero-title">Returns & Exchanges</h1>
          <p className="returns-hero-description">
            Hassle-free returns within 30 days of delivery.
          </p>
        </div>
      </section>

      {/* Return Steps */}
      <section className="return-steps-section">
        <div className="container">
          <h2 className="section-title">How to Return an Item</h2>
          <div className="steps-grid">
            {steps.map((step, index) => (
              <div key={index} className="step-card">
                <div className="step-icon">{step.icon}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Return Policy Details */}
      <section className="policy-details">
        <div className="container">
          <div className="policy-grid">
            <div className="policy-content">
              <h2>Return Policy</h2>
              
              <div className="policy-item">
                <h3>Eligibility</h3>
                <p>Items must be returned within 30 days of delivery. Merchandise must be unworn, unwashed, and in original condition with all tags attached. Items marked as "Final Sale" cannot be returned.</p>
              </div>

              <div className="policy-item">
                <h3>Non-Returnable Items</h3>
                <ul className="policy-list">
                  <li>Final sale items</li>
                  <li>Gift cards</li>
                  <li>Intimate apparel</li>
                  <li>Items worn or altered</li>
                  <li>Items without original tags</li>
                </ul>
              </div>

              <div className="policy-item">
                <h3>Return Shipping</h3>
                <p>Return shipping is free for all US orders. A prepaid return label will be provided upon request. For international returns, customers are responsible for return shipping costs.</p>
              </div>

              <div className="policy-item">
                <h3>Refund Processing</h3>
                <p>Refunds are processed within 5-7 business days after we receive your return. Funds will be credited to your original payment method. Please allow additional time for your bank to process the refund.</p>
              </div>

              <div className="policy-item">
                <h3>Exchanges</h3>
                <p>We process exchanges as a return and new purchase. For the fastest service, please return your item and place a new order for the desired item.</p>
              </div>
            </div>

            <div className="policy-sidebar">
              <div className="sidebar-box">
                <h3>Need Help?</h3>
                <p>Our customer service team is here to assist with returns and exchanges.</p>
                <Link to="/contact" className="sidebar-btn">CONTACT US</Link>
              </div>

              <div className="sidebar-box">
                <h3>Quick Links</h3>
                <ul className="sidebar-links">
                  <li><Link to="/track-order">Track Your Order</Link></li>
                  <li><Link to="/shipping">Shipping Information</Link></li>
                  <li><Link to="/faq">FAQ</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Important Notes */}
      <section className="important-notes">
        <div className="container">
          <div className="notes-box">
            <FiAlertCircle className="notes-icon" />
            <h3>Important Notes</h3>
            <ul className="notes-list">
              <li>Refunds are issued to the original payment method</li>
              <li>Sale items are final sale and cannot be returned</li>
              <li>Gift recipients can return items for store credit</li>
              <li>International returns are subject to shipping costs</li>
              <li>Please allow 5-7 business days for refund processing</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Start Return CTA */}
      <section className="return-cta">
        <div className="container">
          <div className="cta-box">
            <h2>Ready to Make a Return?</h2>
            <p>Start your return process by contacting our customer service team.</p>
            <Link to="/contact" className="cta-btn">START RETURN</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Returns;